module.exports = __webpack_public_path__ + "img/sparkles_2728.dc99992b.png";